module.exports = __webpack_public_path__ + "img/ring_y_i_0_1.4e3cdb65.png";